import React from 'react';
import { Container, Box } from '@chakra-ui/react';
import RegisterForm from '../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
  return (
    <Container maxW="container.sm" py={{ base: 6, md: 10 }} px={{ base: 4, md: 6 }}>
      <Box>
        <RegisterForm />
      </Box>
    </Container>
  );
};

export default RegisterPage; 